module.exports = __webpack_public_path__ + "cr.svg?7f553c0ac6b72071c5360bb22408a88d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/cr.svg
// module id = 1032
// module chunks = 27